import { ErrorMessage, Field, Formik } from 'formik';
import React,{useEffect,useState,useRef} from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col } from 'react-bootstrap';
import './Footer.styles.css';
import * as Yup from 'yup';

const Footer = ({ firstProp, secondProp, displayFooterTop = true }) => {

  const emailRef = useRef()

  const [footerList,setfooterList]=useState([]);
  const [footer,setfooter]=useState(false);
  const [followUs,setFollowUS]=useState([]);
  const [footerBanner,setFooterBanner]=useState(false);

  const getFooterList= async () => {
      await Axios.get('/cms/Footer')
      .then(function (response) {
      if(response.data && response.data.data && response.data.data.Footer){
        const responseData=response.data.data.Footer[0].submenus;
        if(responseData.length>0){
          responseData.map(data=>{
            data.submenus.map(map=>{
              map.newUrl=`/page?name=${map.title.replaceAll(" ","_").toLowerCase()}`;
            })
          })
          setfooterList(responseData);
        }
        else{
          setfooterList([]);
        }
      }})
      .catch(function (error) {
        setfooterList([]);
      });
  };

  const getFooter= async () => {
    await Axios.get('/cms/home-website-info')
    .then(function (response) {
      if(response.data && response.data.footer && response.data.footer.content){
          setfooter(response.data.footer.content);
      }
      else{
        setfooter(false);
      }
    }).catch(function (error) {
        setfooter(false);
      });
  };

  const getFollowUS= async () => {
    await Axios.get('/cms/home-follow-us')
    .then(function (response) {
      if(response.data){
        setFollowUS(response.data);
      }
      else{
        setFollowUS(false);
      }
    }).catch(function (error) {
      setFollowUS(false);
      });
  };

  const getFooterBanner= async () => {
    await Axios.get('/cms/home-footer-banner')
    .then(function (response) {
      if(response.data){
        // setFooterBanner({background: 'no-repeat url(' + response.data.image+')',backgroundSize: "contain",backgroundPosition:'center', minHeight:'150px'});
        setFooterBanner({background: 'no-repeat url(' + response.data.image+')',backgroundSize: "contain",backgroundPosition:'center',backgroundSize:'cover',minHeight:'500px'});
      }
      else{
        setFooterBanner(false);
      }
    }).catch(function (error) {
        setFooterBanner(false);
    });
  };

  useEffect(() => {
    getFooterList();
    getFollowUS();
    getFooter();
    getFooterBanner();
  }, [])

  var RenderData = () =>{
    return (
      <ul className="inline-mode">
      {
        followUs && followUs.map((data,i)=> {
          <li className="social-network fb" key={i}><a title="Connect us on Facebook" href="#" ><i
            className="fa fa-facebook"></i></a></li>
        })
      }
      {/* <li className="social-network fb"><a title="Connect us on Facebook" href="#"><i
        className="fa fa-facebook"></i></a></li>
      <li className="social-network googleplus"><a title="Connect us on Google+" href="#"><i
        className="fa fa-google-plus"></i></a></li>
      <li className="social-network tw"><a title="Connect us on Twitter" href="#"><i
        className="fa fa-twitter"></i></a></li>
      <li className="social-network linkedin"><a title="Connect us on Linkedin" href="#"><i
        className="fa fa-linkedin"></i></a></li>
      <li className="social-network rss"><a title="Connect us on rss" href="#"><i className="fa fa-rss"></i></a>
      </li>
      <li className="social-network instagram"><a title="Connect us on Instagram" href="#"><i className="fa fa-instagram"></i></a></li> */}
    </ul>
    );
  };

  return (
    <footer>
      {displayFooterTop ? "" : <div style={{ marginTop: '20px' }}></div>}
      {footerBanner && 
        <div className="footer-top" style={footerBanner}>
          <Container></Container>
        </div>
      }
      <div className="footer-inner">
        <Container>
          <Row>
            {footerList.map((data,index) => (

              <Col sm={4} xs={12} md={3} key={index}>
                <div className="footer-links">
                  <h4>{data?.title || "Information"}</h4>
                  <ul className="links">
                    {data?.submenus?.map((list,index) => (
                      <li key={index}><a href={list?.newUrl}>{list?.title}</a></li>
                    ))}
                    {/* <li><a href="#">Brands</a></li>
                      <li><a href="#">Delivery Info</a></li>
                      <li><a href="contact_us.html">Contact Us</a></li>
                      <li><a href="#">Microsoft Education Program</a></li> */}
                  </ul>
                </div>
              </Col>
            ))}
            {/* <Col sm={4} xs={12} md={3}>
                  <div className="footer-links">
                    <h4>Legal</h4>
                    <ul className="links">
                      <li><a href="#" title="Online Store Policy">Online Store Policy</a></li>
                      <li><a href="#" title="Privacy Policy">Privacy Policy</a></li>
                      <li><a href="#" title="Terms &amp; Conditions">Terms &amp; Conditions</a></li>
                    </ul>
                  </div>
                </Col> */}
            <Col xs={12} sm={12} md={6}>
              <div className="footer-links">
                <div className="footer-newsletter">
                  <h4>Subscribe to our news</h4>
                  <Formik
                    initialValues={{ email: "" }}
                    validationSchema={
                      Yup.object().shape({
                        email: Yup.string()
                          .email("Email is invalid")
                          .required("Email is required")
                      })}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      emailRef.current.focus()
                      // console.log("Values", values);
                      setSubmitting(false);
                      resetForm();
                    }}
                  >
                    {(props) => {
                      const {
                        values,
                        touched,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting
                      } = props;
                      return (
                        <form onSubmit={handleSubmit}>
                          <div className="newsletter-inner">
                            <p>Subscribe to be the first to know about Sales, Events, and Exclusive Offers!</p>
                            <input Labels="Email Address"
                              Type="email"
                              Name="email" placeholder='Enter Your Email'
                              value={values.email}
                              ref={emailRef}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={errors.email && touched.email ? 'is-invalid newsletter-email' : "newsletter-email"}
                            />

                            {/* <InputField
                              Labels="Email Address"
                              Type="email"
                              Name="email"
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={!!errors.email}
                              className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                            /> */}
                            <button className="button subscribe" type="submit" onClick={() => emailRef.current.focus()} disabled={isSubmitting} title="Subscribe">Subscribe</button>
                          </div>
                          <ErrorMessage component="div" name="email" style={{ color: "red", marginBottom: "5px" }} />
                        </form>
                      );
                    }}
                  </Formik>
                </div>
                <div className="social">
                  <h4>Follow Us</h4>
                  <ul className="inline-mode">
                    {
                      followUs && followUs.map((data,i)=> {
                        return(<li className="social-network fb" key={i}><a title="Connect us on Facebook" href={data.url}><i
                          className={data.type=="googleplus"?"fa fa-google-plus":"fa fa-"+data.type}></i></a></li>)
                      })
                    }
                    {/* <li className="social-network fb"><a title="Connect us on Facebook" href="#"><i
                      className="fa fa-facebook"></i></a></li>
                    <li className="social-network googleplus"><a title="Connect us on Google+" href="#"><i
                      className="fa fa-google-plus"></i></a></li>
                    <li className="social-network tw"><a title="Connect us on Twitter" href="#"><i
                      className="fa fa-twitter"></i></a></li>
                    <li className="social-network linkedin"><a title="Connect us on Linkedin" href="#"><i
                      className="fa fa-linkedin"></i></a></li>
                    <li className="social-network rss"><a title="Connect us on rss" href="#"><i className="fa fa-rss"></i></a>
                    </li>
                    <li className="social-network instagram"><a title="Connect us on Instagram" href="#"><i className="fa fa-instagram"></i></a></li> */}
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="footer-bottom">
        <Container>
          <Row>
            <Col sm={5} xs={12} className="coppyright">{footer && footer}</Col>
            {/* <Col sm={5} xs={12} className="payment-accept">
              <ul>
                <li> <a href="#"><img src="images/payment-1.png" alt="Payment Card" /></a> </li>
                <li> <a href="#"><img src="images/payment-2.png" alt="Payment Card" /></a> </li>
                <li> <a href="#"><img src="images/payment-3.png" alt="Payment Card" /></a> </li>
                <li> <a href="#"><img src="images/payment-4.png" alt="Payment Card" /></a> </li>
              </ul>
            </Col> */}
          </Row>
        </Container>
      </div>
    </footer >
  );
};

export default Footer;
